import React, {useState} from 'react';
import {ResponsiveBullet} from '@nivo/bullet';
import CustomLegend from './CustomLegend';
import "../ServiceRequests/AddServiceRequest.css";
import '@patternfly/react-core/dist/styles/base.css';
import Box from "@mui/material/Box";
import {makeStyles} from '@mui/styles';

let renderLegend = false;

function BulletChart({chartType, projectType, serviceRequestInfo}) {
    const [totalHours] = useState(serviceRequestInfo.allocatedBudget);
    const [hrsDisplay] = useState(serviceRequestInfo.budgetUsed);

    const rangeColors = ['#6DEAAC', '#FF9090'];
    const singleColor = '#6DEAAC';

    const extendedRange = hrsDisplay + (hrsDisplay * 0.1);
    const doubleRange = [totalHours, extendedRange];
    const singleRange = [totalHours];

    const ranges = (totalHours, hrsDisplay) => {
        if (hrsDisplay > totalHours) {
                return doubleRange
        } else {
            return singleRange;
        }
    };

    const overEndDate = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');

        const todayFormattedDate = `${year}-${month}-${day}`;

        if(todayFormattedDate > serviceRequestInfo.endsOn) {
            return 1
        } else {
            return 2
        }
    }

    const dateCalculation = () => {
        const currentDate = new Date();
        const currentDay = currentDate.getDate();
        const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
        const percentageOfMonthPassed = (currentDay / lastDayOfMonth);
        const hoursTarget = (totalHours * percentageOfMonthPassed)
        const formattedNumber = hoursTarget.toFixed(2);
        return formattedNumber.replace(/\.00$/, '');
    }

    const markerCalculation = () => {
        if(overEndDate() === 1) {
            if(projectType === 1) {
                return totalHours
            } else {
                return dateCalculation()
            }
        } else {
            return dateCalculation()
        }
    }


    const hoverChart = (color) => {
        if (color === '#6DEAAC') {
            return `Allocated hours: ${data[0]?.ranges[0]}hrs`;
        } else if (color === 'black') {
            return `Budget spent: ${data[0]?.measures[0]}hrs`
        } else if (color === '#F1416C') {
            return `Target hours: ${data[0]?.markers[0]}hrs`;
        } else if (color === '#FF9090') {
            return `Over budget: ${hrsDisplay - totalHours}hrs`;
        }
    }


    const colors = (totalHours, hrsDisplay) => {
        if (hrsDisplay > totalHours) {
            legendData = [
            {label: 'Allocated hours', color: '#6deaac'},
            {label: 'Budget spent', color: 'black'},
            {label: 'Over budget', color: '#ff9090'}]
                return rangeColors;
        } else {
            legendData = [{label: 'Allocated hours', color: '#6deaac'},
                {label: 'Budget spent', color: 'black'}]
            return singleColor;
        }
    }

    const data = [{
        id: "",
        ranges: ranges(totalHours, hrsDisplay),
        measures: [hrsDisplay],
        markers: [markerCalculation()],
    }];

    const useStyles = makeStyles((theme) => ({
        centerContent: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '60%'
        },
    }));


    let height;
    let widthChart;

    if (window.location.href.includes("/ServiceRequestDashboard")) {
        height = 150;
        renderLegend = true;
        widthChart = '100%'
    } else if (window.location.href.includes("/ServiceRequestList")) {
        height = 60;
        renderLegend = false;
        widthChart = '95%';
    }

    let legendData = [
        {label: 'Allocated hours', color: '#6deaac'},
        {label: 'Budget spent', color: 'black'},
    ]

    const classes = useStyles();
    const [tooltipData, setTooltipData] = useState(null);

    const handleBulletMouseMove = (event, data) => {
        setTooltipData(data);
        console.log(tooltipData);
    };

    const hideMarker = () => {
        if(projectType === 1) {
            return 0
        }
        else {
            return 1.3
        }
    }


    const chartConfigurations = {
        Fat: {
            data,
            margin: {top: 20, right: 25, bottom: 20, left: 25},
            measureSize: [0.2],
            markerSize: [hideMarker()],
            rangeColors: colors(totalHours, hrsDisplay),
            measureColors: ['black'],
            markerColors: ['#F1416C'],
            onMouseMove: [handleBulletMouseMove],
        },
        Thin: {
            data,
            margin: {top: 10, right: 2, bottom: 10, left: 2},
            measureSize: [0.2],
            markerSize: [hideMarker()],
            rangeColors: colors(totalHours, hrsDisplay),
            measureColors: ['black'],
            markerColors: ['#F1416C'],
            onMouseMove: [handleBulletMouseMove],
        },
    };

    const chartConfiguration = chartConfigurations[chartType];


    return (
        <Box data-testid={"BulletChart"} className={classes.centerContent}>
            <Box style={{height: `${height}px`, width: widthChart}}>
                <ResponsiveBullet
                    tooltip={({color}) => {
                        return (
                            <div className="custom-tooltip">
                                <p>{hoverChart(color)}</p>
                            </div>
                        );
                    }}
                    {...chartConfiguration}/>
                {renderLegend && <CustomLegend id={'legend'} data={legendData}/>}
            </Box>
        </Box>
    );
}

export default BulletChart;
